<modal-component>



	<div class="_context" left>
		<div class="_header">
			<p class="_title">
				{{'BEEGO_APPOINTMENT.TITLE' | translate}} <br>
				<span *ngIf="beegoAppointment.WorkOrder.status === ExtBeegoAppointmentStatus.Canceled">
					 ({{'BEEGO_APPOINTMENT.DETAILS.CANCELLED.TITLE' | translate}})
				</span> 
			</p>
		</div>

		<div class="_beego _info">
			<img class="_logo" src="./assets/BEEGO_logo.png" />

			<info-line icon="./assets/icons/calendar-outline.svg" align="top" >
				<p *ngIf="beegoAppointment.WorkOrder.CalendarEvent">
					{{beegoAppointment.WorkOrder.CalendarEvent.startsAt | date}}, {{beegoAppointment.WorkOrder.CalendarEvent.startsAt | date:"HH:mm" | time}} 
					<ng-container *ngIf="beegoAppointment.WorkOrder.Digipoint">
					 - {{beegoAppointment.WorkOrder.CalendarEvent.endsAt | date:"HH:mm" | time}} 
					</ng-container >
				</p>
				<p *ngIf="!beegoAppointment.WorkOrder.CalendarEvent">
					{{beegoAppointment?.WorkOrder?.Appointment?.appointmentDate | date}}, {{beegoAppointment?.WorkOrder?.Appointment?.appointmentTime | time}}
				</p>
			</info-line>


			<info-line icon="./assets/icons/time-outline.svg" align="top" *ngIf="!isInPast && !beegoAppointment.WorkOrder.WorkOrderCancellation">
				<p>{{'BEEGO_APPOINTMENT.TIME_INFO_START' | translate }} 
					{{appointmentDate | date:"HH:mm:ss" | time}}
					{{ 'BEEGO_APPOINTMENT.TIME_INFO_AND' | translate }} 
					{{appointmentBufferEnd | date:"HH:mm:ss" | time}}
					{{'BEEGO_APPOINTMENT.TIME_INFO_END' | translate }}
				</p>
			</info-line>

		
			<div class="_beego-student">
				<ion-icon src="./assets/icons/employees-outline.svg"></ion-icon>
				<div class="_details">
					<p>
						<b [translate]="'BEEGO_APPOINTMENT.STUDENT'"></b><br/>
						{{beegoAppointment.WorkOrder.Employee.firstname}} {{beegoAppointment.WorkOrder.Employee.name}}
					</p>
					<img [src]="beegoAppointment.WorkOrder?.Employee?.pictureUrl" /> 
				</div>
			</div>

			<info-line icon="./assets/icons/absent-outline.svg" align="top" >
				<p [innerHTML]="'BEEGO_APPOINTMENT.CANCEL_INFO' | translate"></p>
			</info-line>
			
			<info-line icon="./assets/icons/euro-outline.svg" align="top" >
				<p><b [translate]="'BEEGO_APPOINTMENT.PAYMENT_INFO_TITLE'"></b></p>
				<p [translate]="'BEEGO_APPOINTMENT.PAYMENT_INFO'"></p>
			</info-line>
		</div>

		
		
	</div>

	

	<div class="_appointment-details" right>
		
		<ng-container *ngIf="!beegoAppointment.WorkOrder.Digipoint">
			<p class="_title" [translate]="'BEEGO_APPOINTMENT.CLIENT_TITLE'"></p>
			<ng-container *ngIf="beegoAppointment.Client">
				<client-details-component [client]="beegoAppointment.Client"></client-details-component>
			</ng-container>
			<ng-container *ngIf="!beegoAppointment.Client">
				<!-- Legacy Beego appointment not existing in Digiportal -->
				<info-line icon="./assets/icons/user-outline.svg">
					<p>{{beegoAppointment.WorkOrder.Appointment.Client.firstname}} {{beegoAppointment.WorkOrder.Appointment.Client.name}}</p>
				</info-line>
			
				<info-line icon="./assets/icons/location-outline.svg" *ngIf="beegoAppointment.WorkOrder.Appointment.Client.ClientAddress">
					<p [navigate]="[InternalNavigationType.address, beegoAppointment.WorkOrder.Appointment.Client.ClientAddress]">		
						{{beegoAppointment.WorkOrder.Appointment.Client.ClientAddress.street}} 
						{{beegoAppointment.WorkOrder.Appointment.Client.ClientAddress.housenumber}}
						{{beegoAppointment.WorkOrder.Appointment.Client.ClientAddress.floor}},
						{{beegoAppointment.WorkOrder.Appointment.Client.ClientAddress.zipcode}}
						{{beegoAppointment.WorkOrder.Appointment.Client.ClientAddress.city}}
					</p>
				</info-line>
		
				<info-line icon="./assets/icons/email-outline.svg" *ngIf="beegoAppointment.WorkOrder.Appointment.Client.email">
					<p [navigate]="[InternalNavigationType.email, beegoAppointment.WorkOrder.Appointment.Client.email]">{{beegoAppointment.WorkOrder.Appointment.Client.email}}</p>
				</info-line>		
			
				<info-line icon="./assets/icons/mobile-outline.svg" *ngIf="beegoAppointment.WorkOrder.Appointment.Client.mobile">
					<p [navigate]="[InternalNavigationType.phone, beegoAppointment.WorkOrder.Appointment.Client.mobile]">{{beegoAppointment.WorkOrder.Appointment.Client.mobile}}</p>
				</info-line>
		
				<info-line icon="./assets/icons/phone-outline.svg" *ngIf="beegoAppointment.WorkOrder.Appointment.Client.phone">
					<p [navigate]="[InternalNavigationType.phone, beegoAppointment.WorkOrder.Appointment.Client.phone]">{{beegoAppointment.WorkOrder.Appointment.Client.phone}}</p>
				</info-line>		
			
				<info-line icon="./assets/icons/calendar-outline.svg" align="top" *ngIf="beegoAppointment.WorkOrder.Appointment.Client.birthYear">
					<p [translate]="'CLIENT.EXTRA.BIRTH_DATE'"></p>
					<p>{{beegoAppointment.WorkOrder.Appointment.Client.birthYear | date:"yyyy"}}</p>
				</info-line>
			</ng-container>
			
		</ng-container>
		<ng-container *ngIf="beegoAppointment.WorkOrder.Digipoint">
			<p class="_title" [translate]="'BEEGO_APPOINTMENT.DIGIPOINT_TITLE'"></p>

			<info-line icon="./assets/icons/digipoint-outline.svg" align="top">
				<p>
					{{beegoAppointment.WorkOrder.Digipoint.name}}
				</p>	
				<p [navigate]="[InternalNavigationType.address, beegoAppointment.WorkOrder.Digipoint.DigipointAddress]">
					{{beegoAppointment.WorkOrder.Digipoint.DigipointAddress | address}}
				</p>
			</info-line>
		</ng-container>			


		<p class="_title" [translate]="'BEEGO_APPOINTMENT.DETAILS_TITLE'"></p>

		<ng-container [ngSwitch]="beegoAppointment.WorkOrder.status">
			<ng-container *ngSwitchCase="ExtBeegoAppointmentStatus.Open">
				<info-line icon="./assets/icons/info-outline.svg" align="top">
					<p><b>{{'BEEGO_APPOINTMENT.DETAILS.STATUS.TITLE' | translate}}</b></p>
					<p>{{'BEEGO_APPOINTMENT.DETAILS.STATUS.TODO' | translate}}</p>
				</info-line>

				<info-line icon="./assets/icons/credit-card-outline.svg" align="top" *ngIf="beegoAppointment.WorkOrder.DiscountCodes?.length > 0">
					<p><b>{{'BEEGO_APPOINTMENT.DETAILS.DIGICHEQUES_ADDED' | translate}}</b></p>
					<p>{{beegoAppointment.WorkOrder.DiscountCodes.length }} (<span *ngFor="let digichequeCode of beegoAppointment.WorkOrder.DiscountCodes"> {{digichequeCode.code}} </span>)</p>
				</info-line>
			</ng-container>

			<ng-container *ngSwitchCase="ExtBeegoAppointmentStatus.Canceled">	
				<info-line icon="./assets/icons/info-outline.svg" align="top">
					<p><b>{{'BEEGO_APPOINTMENT.DETAILS.STATUS.TITLE' | translate}}</b></p>
					<p [innerHTML]="'BEEGO_APPOINTMENT.DETAILS.STATUS.CANCELLED' | translate"></p>
				</info-line>

				<info-line icon="./assets/icons/calendar-outline.svg" align="top">
					<p><b>{{'BEEGO_APPOINTMENT.DETAILS.CANCELLATION_DATE' | translate}}</b></p>
					<p>{{beegoAppointment.WorkOrder.WorkOrderCancellation.createdAt | date:'dd/MM/yyyy - HH:mm'}}</p>
				</info-line>

				<info-line icon="./assets/icons/info-outline.svg" align="top" *ngIf="beegoAppointment.WorkOrder.WorkOrderCancellation.atFault">
					<p><b>{{'BEEGO_APPOINTMENT.AT_FAULT.TITLE_LONG' | translate}}</b></p>
					<p>
						<ng-container *ngIf="(beegoAppointment.WorkOrder?.WorkOrderCancellation?.atFault ?? []).includes('partner') && beegoAppointment.CancelledBy">
							{{beegoAppointment.CancelledBy.Employee.firstname}} {{beegoAppointment.CancelledBy.Employee.lastname}} ({{beegoAppointment.CancelledBy.email}})
						</ng-container>

						<ng-container *ngIf="!(beegoAppointment.WorkOrder?.WorkOrderCancellation?.atFault ?? []).includes('partner')">
							<ng-container *ngFor="let atFault of beegoAppointment.WorkOrder?.WorkOrderCancellation?.atFault">
								{{"BEEGO_APPOINTMENT.AT_FAULT."+atFault | uppercase | translate }}
							</ng-container>	
						</ng-container>
					</p>
				</info-line>

				<info-line icon="./assets/icons/info-outline.svg" align="top">
					<p><b>{{'BEEGO_APPOINTMENT.DETAILS.CANCELLATION_REASON' | translate}}</b></p>
					<p>{{beegoAppointment.WorkOrder.WorkOrderCancellation.reason}}</p>
				</info-line>
			</ng-container>

			<ng-container *ngSwitchCase="BeegoAppointmentStatus.Unfinished">

				<info-line icon="./assets/icons/info-outline.svg" align="top">
					<p><b>{{'BEEGO_APPOINTMENT.DETAILS.STATUS.TITLE' | translate}}</b></p>
					<p [innerHTML]="'BEEGO_APPOINTMENT.DETAILS.STATUS.UNFINISHED' | translate"></p>
				</info-line>

				<info-line icon="./assets/icons/credit-card-outline.svg" align="top" *ngIf="beegoAppointment.WorkOrder.DiscountCodes?.length > 0">
					<p><b>{{'BEEGO_APPOINTMENT.DETAILS.DIGICHEQUES' | translate}}</b></p>
					<p>{{beegoAppointment.WorkOrder.DiscountCodes.length }} (<span *ngFor="let digichequeCode of beegoAppointment.WorkOrder.DiscountCodes"> {{digichequeCode.code}} </span>)</p>
				</info-line>

			</ng-container>

			<ng-container *ngSwitchCase="ExtBeegoAppointmentStatus.Finished">

				<info-line icon="./assets/icons/info-outline.svg" align="top">
					<p><b>{{'BEEGO_APPOINTMENT.DETAILS.STATUS.TITLE' | translate}}</b></p>
					<p>{{'BEEGO_APPOINTMENT.DETAILS.STATUS.FINISHED' | translate}}</p>
				</info-line>

				<info-line icon="./assets/icons/time-outline.svg" align="top">
					<p><b>{{'BEEGO_APPOINTMENT.DETAILS.TIME' | translate}}</b></p>
					<p>{{beegoAppointment.WorkOrder.time / 2 | number:'1.0-1'}}{{'H' | translate}}</p>
				</info-line>

				<info-line icon="./assets/icons/credit-card-outline.svg" align="top" *ngIf="beegoAppointment.WorkOrder.DigichequeCodes?.length > 0">
					<p><b>{{'BEEGO_APPOINTMENT.DETAILS.DIGICHEQUES' | translate}}</b></p>
					<p>{{beegoAppointment.WorkOrder.DigichequeCodes.length }} (<span *ngFor="let digichequeCode of beegoAppointment.WorkOrder.DigichequeCodes"> {{digichequeCode.code}} </span>)</p>
				</info-line>

				<info-line icon="./assets/icons/cash-outline.svg" align="top">
					<p><b>{{'BEEGO_APPOINTMENT.DETAILS.AMOUNT' | translate}}</b></p>
					<p>{{beegoAppointment.WorkOrder.amount | currency}}</p>
				</info-line>

				<info-line icon="./assets/icons/workorder-outline.svg" align="top">
					<p><b>{{'BEEGO_APPOINTMENT.DETAILS.WORKORDER' | translate}}</b></p>
					<p>{{beegoAppointment.WorkOrder.description}}</p>
				</info-line>

				<info-line icon="./assets/icons/reviews-outline.svg" align="top" class="_review">
					<p><b>{{'BEEGO_APPOINTMENT.DETAILS.RATING' | translate}}</b></p>

					<ng-container *ngIf="beegoAppointment.WorkOrder.Appointment.Rating">
						<div class="_review-score">
							<ion-icon *ngFor="let i of ' '.repeat(beegoAppointment.WorkOrder.Appointment.Rating.score).split(''), let x = index" src="./assets/icons/reviews.svg"></ion-icon>
						</div>
						
						<p class="_review-description">"{{beegoAppointment.WorkOrder.Appointment.Rating.description}}"</p>
					</ng-container>

					<ng-container *ngIf="!beegoAppointment.WorkOrder.Appointment.Rating">
						<p>{{'BEEGO_APPOINTMENT.DETAILS.NO_RATING' | translate}}</p>
					</ng-container>
					
				</info-line>

				<ng-container *ngIf="(beegoAppointment.WorkOrder.Payment?.PaymentMethods || []).length > 0">
					<p><b>{{'BEEGO_APPOINTMENT.DETAILS.PAYMENT_METHOD' | translate}}</b></p>

					<info-line icon="{{'./assets/icons/' + getPaymentMethodIcon(method.name) +'.svg'}}" align="top" *ngFor="let method of beegoAppointment.WorkOrder.Payment.PaymentMethods">
						<p><b>{{method.name}}</b></p>
						<p>{{method.PaymentMethodsOnPayment.amount | currency}}</p>
					</info-line>
				</ng-container>
			</ng-container>	
		</ng-container>

		<info-line icon="./assets/icons/created-by-outline.svg" align="top" *ngIf="beegoAppointment.CreatedBy">
			<p><b><span>{{'EVENT.CREATED_BY' | translate}}: </span></b><span [navigate]="[InternalNavigationType.email, beegoAppointment.CreatedBy?.email]">{{beegoAppointment.CreatedBy?.email}}</span> 
			</p>
			<p style="color: grey">{{beegoAppointment.createdAt | date:"EEEE d MMM yyyy"}}</p>
		</info-line>
	
		<info-line icon="./assets/icons/problem-outline.svg" align="top" *ngIf="beegoAppointment.WorkOrder.Appointment">
			<p><b>{{'BEEGO_APPOINTMENT.QUESTION' | translate}}</b></p>
			<p>{{beegoAppointment.WorkOrder.Appointment.problem}}</p>
		</info-line>
	</div>

	<ng-container buttons>
		<ng-container *ngIf="this.beegoAppointment.WorkOrder.status === ExtBeegoAppointmentStatus.Open">
			<button (click)="this.deleteAppointment()" class="_button _delete-button" *ngIf="!this.isInPast">
				<span [translate]="'BEEGO_APPOINTMENT.DELETE'"></span>
			</button>
			<button class="_button _print-button" (click)="print()">
				<ion-icon src="./assets/icons/print-outline.svg"></ion-icon>
				<span [translate]="'PRINT'"></span>
			</button>
		</ng-container>
		<button (click)="close()" class="_button _cancel-button" [translate]="'BACK'" ></button>
	</ng-container>



</modal-component>
